var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 4L4 8l8 4l8-4zm-8 8l8 4l8-4M4 16l8 4l8-4"
    }, null, -1)
  ]));
}
__name(render, "render");
const stack2 = markRaw({ name: "tabler-stack-2", render });
export {
  stack2 as default
};
//# sourceMappingURL=stack-2.js.map
